import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { addTicket, GetMasterCategaryData } from "./LeadService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TostMsg } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Dropdown } from "primereact/dropdown";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

function AddLead() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [howItWorkFirst, setHowItWorkFirst] = useState("");
  const [howItWorkSecond, setHowItWorkSecond] = useState("");
  const [howItWorkThird, setHowItWorkThird] = useState("");
  const [howItWorkFourth, setHowItWorkFourth] = useState("");
  const [howItWorkFifth, setHowItWorkFifth] = useState("");
  const [howItWorkSixth, setHowItWorkSixth] = useState("");
  const [howItWorkSeventh, setHowItWorkSeventh] = useState("");
  let history = useHistory();
  const [userAddPermission, setUserAddPermission] = useState(false);

  useEffect(() => {
    GetMasterSystemAlertList();
    permissionAccouncementList();
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getMasterTicketPriority();
    getMasterTicketSeverity();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === selectedCategory
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
  }, [selectedCategory]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Ticket.Add") {
        setUserAddPermission(true);
      }
    });
  };

  const addTicketValidation = Yup.object().shape({
    requestTitle: Yup.string().required("Request title is mandatory"),
    requestDescription: Yup.string(),
    requestCategoryId: Yup.string().required("Category is mandatory"),
    requestSubCategoryId: Yup.string().required("Sub category is mandatory"),
    serverityId: Yup.string().required("Severity is mandatory"),
    priority: Yup.string().required("Priority is mandatory"),
  });

  const addTicketForm = useFormik({ 
    initialValues: {
      requestTitle: "",
      requestDescription: "",
      requestCategoryId: "",
      requestSubCategoryId: "",
      serverityId: "",
      priority: "",
    },
    validationSchema: addTicketValidation,
    onSubmit: async (data) => {
      if (userAddPermission == false) {
        toster.current.warn("only authorised user can add this ticket");
      } else {
        setIsloading(true);
        const body = {
          Id: 0,
          OrgId: userDetails?.OrgId,
          EmpId: userDetails?.EmpId,
          RequestTitle: data?.requestTitle,
          RequestDescription: data?.requestDescription,
          RequestCategoryId: Number(data?.requestCategoryId),
          RequestSubCategoryId: Number(data?.requestSubCategoryId),
          Comment: "", //data?.comment,
          Severity: Number(data?.serverityId),
          Priority: Number(data?.priority),
          AssignedToId: 0,
          RequestStatusId: 0 , //101,
        };
        try {
          await addTicket(body);
          // GetMasterSystemAlertList("Ticket_Added");
          setIsloading(false);
          addTicketForm.resetForm();
          setTimeout(() => {
            history.push("/Leads");
          }, 1000);
        } catch (error) {}
      }
    },
  });

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketPriority() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Priority",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketPriorityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSeverity() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Severity",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSeverityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_First") {
        setHowItWorkFirst(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Second") {
        setHowItWorkSecond(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Third") {
        setHowItWorkThird(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Fourth") {
        setHowItWorkFourth(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Fifth") {
        setHowItWorkFifth(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Sixth") {
        setHowItWorkSixth(msg?.Desc);
      } else if (msg?.Name == "How_It_Work_Seventh") {
        setHowItWorkSeventh(msg?.Desc);
      }
    });
  }, []);

  return (
    <>
      <div>
        <div id="circular-menu" className="circular-menu position-relation">
          <a className="floating-btn">
            <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
            <i aria-hidden="true" className="fa fa-times"></i>
          </a>

          <div className="items-wrapper">
            <div className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <Link
              className="menu-item is-flex right-panel-trigger"
              data-panel="languages-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <Link href="" className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <Link
              className="menu-item is-flex right-panel-trigger"
              data-panel="activity-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </Link>
          </div>
        </div>

        <div className="container-fluid  position-relation">
          <div className="row">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">{T("Add Leage")}</h2>
              </div>
              <div className="rightside-tabs">
                <Link to="/Leads">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
            <div className="edit-ticket mt-4 mb-4">
              <div className="w-100">
                <div className="row">
                  <div className="col-md-8">
                    <div className="employee-card tile-grid tile-grid-v1">
                      <div id="feed-post-1" className="addticketform">
                        <div className="third-section">
                          <form onSubmit={addTicketForm.handleSubmit}>
                            <div className="row">
                              <div className="mb-4 col-md-12">
                                <div className="cover-form">
                                  <label className="form-label">Title</label>
                                  <input
                                    type="text"
                                    cols="1"
                                    rows="4"
                                    name="requestTitle"
                                    className={
                                      "form-control bg-chng" +
                                      (addTicketForm.errors.requestTitle &&
                                      addTicketForm.touched.requestTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={addTicketForm.handleChange}
                                    value={addTicketForm.values.requestTitle}
                                    placeholder="Summary of ticket"
                                  />
                                  <div className="invalid-feedback">
                                    {addTicketForm.errors.requestTitle &&
                                    addTicketForm.touched.requestTitle
                                      ? addTicketForm.errors.requestTitle
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mb-4 col-md-12">
                              <div className="cover-form">
                                <label className="form-label">
                                  Description
                                </label>
                                <textarea
                                  rows="6"
                                  cols="1"
                                  name="requestDescription"
                                  className="form-control"
                                  onChange={addTicketForm.handleChange}
                                  value={
                                    addTicketForm.values.requestDescription
                                  }
                                  placeholder="Description of ticket"
                                ></textarea>
                              </div>
                            </div>
                            <div className="row">
                              <div className="mb-4 col-md-12">
                                <div className="cover-form">
                                  <label className="form-label">Category</label>
                                  <Dropdown
                                    value={selectedCategory}
                                    onFocus={(e) => e.target.click()}
                                    onChange={(e) => {
                                      setSelectedCategory(e.value);
                                      addTicketForm.setFieldValue(
                                        "requestCategoryId",
                                        e.value
                                      );
                                    }}
                                    options={ticketCategoryType}
                                    optionLabel="Name"
                                    optionValue="Id"
                                    filter
                                    placeholder="Category"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {addTicketForm.errors.requestCategoryId &&
                                  addTicketForm.touched.requestCategoryId
                                    ? addTicketForm.errors.requestCategoryId
                                    : null}
                                </div>
                              </div>
                              <div className="mb-4 col-md-12">
                                <div className="cover-form">
                                  <label className="form-label">
                                    Sub Category
                                  </label>
                                  <Dropdown
                                    name="subCategory"
                                    value={selectedSubCategory}
                                    onFocus={(e) => e.target.click()}
                                    onChange={(e) => {
                                      setSelectedSubCategory(e.value);
                                      addTicketForm.setFieldValue(
                                        "requestSubCategoryId",
                                        e.value
                                      );
                                    }}
                                    options={ticketSubcategoryTypeSelected}
                                    optionLabel="Name"
                                    optionValue="Id"
                                    filter
                                    placeholder="Sub Category"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {addTicketForm.errors.requestSubCategoryId &&
                                  addTicketForm.touched.requestSubCategoryId
                                    ? addTicketForm.errors.requestSubCategoryId
                                    : null}
                                </div>
                              </div>
                              <div className="mb-4 col-md-6">
                                <div className="cover-form">
                                  <label className="form-label">Priority</label>
                                  <Dropdown
                                    name="priority"
                                    value={selectedPriority}
                                    onFocus={(e) => e.target.click()}
                                    onChange={(e) => {
                                      setSelectedPriority(e.value);
                                      addTicketForm.setFieldValue(
                                        "priority",
                                        e.value
                                      );
                                    }}
                                    options={ticketPriorityType}
                                    optionLabel="Name"
                                    optionValue="Id"
                                    filter
                                    placeholder="Priority"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {addTicketForm.errors.priority &&
                                  addTicketForm.touched.priority
                                    ? addTicketForm.errors.priority
                                    : null}
                                </div>
                              </div>
                              <div className="mb-4 col-md-6">
                                <div className="cover-form">
                                  <label className="form-label">Severity</label>
                                  <Dropdown
                                    name="SeverityName"
                                    value={selectedServerity}
                                    onFocus={(e) => e.target.click()}
                                    onChange={(e) => {
                                      setSelectedServerity(e.value);
                                      addTicketForm.setFieldValue(
                                        "serverityId",
                                        e.value
                                      );
                                    }}
                                    options={ticketSeverityType}
                                    optionLabel="Name"
                                    optionValue="Id"
                                    filter
                                    placeholder="Severity"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {addTicketForm.errors.serverityId &&
                                  addTicketForm.touched.serverityId
                                    ? addTicketForm.errors.serverityId
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <a>
                                <button
                                  className="add-newticket w-auto float-right btn btn-purple"
                                  type="submit"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    className="bi bi-check"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                  </svg>
                                  Submit your request
                                </button>
                              </a>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="side-add-section">
                      <div className="card right-div mt-0">
                        <div className="card-body">
                          <div className="text-center">
                            <h4 className="how-it mb-4">How it work ?</h4>
                            <img
                              src="images/org-img/leave/leave_adjustment.svg"
                              style={{ width: "70%" }}
                            />
                            <ul className="ul-work text-dark text-left mt-4">
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkFirst}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkSecond}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkThird}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkFourth}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkFifth}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkSixth}.
                              </li>
                              <li>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="11"
                                  fill="currentColor"
                                  className="bi bi-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <circle cx="8" cy="8" r="8" />
                                </svg>
                                <span> </span>
                                {howItWorkSeventh}.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default AddLead;
